// src\pages\ForgotPassword.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setNotice("");

    try {
      // POST /auth/forgot-password  { email }
      await api.post("/auth/forgot-password", { email });

      // Always show a generic success to avoid email enumeration UX
      setSent(true);
      setNotice(
        "If that email exists, we’ve sent a 6-digit reset code. It expires in 15 minutes."
      );
    } catch (err) {
      // Backend may return 404 (email not found) or 403 (inactive).
      // Keep the UX generic unless it’s clearly actionable.
      if (err?.response?.status === 403) {
        setError("This account is inactive. Please contact your administrator.");
      } else {
        setSent(true);
        setNotice(
          "If that email exists, we’ve sent a 6-digit reset code. It expires in 15 minutes."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h1>Forgot password</h1>
      <p>Enter your email and we’ll send a reset code.</p>

      <form onSubmit={onSubmit} className="auth-form">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          required
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={loading || sent}
        />

        {!sent && (
          <button className="primary-btn" type="submit" disabled={loading}>
            {loading ? "Sending…" : "Send code"}
          </button>
        )}
      </form>

      {notice && <p className="success-message" role="status">{notice}</p>}
      {error && <p className="error-message" role="alert">{error}</p>}

      {sent && (
        <div style={{ marginTop: 16 }}>
          <button
            className="secondary-btn"
            onClick={() => navigate(`/reset-password?email=${encodeURIComponent(email)}`)}
          >
            Continue to reset
          </button>
        </div>
      )}
    </div>
  );
}
